<template lang="pug">
  .flow-builder-block.flow-preview(@dblclick="$emit('dblclick:block', flow_id)")
    .flow-header.d-flex.align-items-center
      external-link-icon.icon-sm.mr-2
      span Lleva a otro flujo
    .flow-body
      p.mb-1.uppercase.text-help.text-sm Flujo
      h4.mb-4 {{ name || 'Flujo sin nombre' }}
      b-form-row
        b-col
          b-button(variant="light", block, size="lg", :to="{name: 'Flow builder', params: { flow_id: flow_id } }") Abrir flujo
        b-col(cols="auto")
          b-button(variant="light", block, size="lg", :to="{name: 'Flow builder', params: { flow_id: flow_id } }", target="_blank")
            external-link-icon.icon-sm
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    flow_id: {
      default: ''
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';
  $block-border-radius: 1rem;

  .flow-builder-block {
    color: $dark;
    width: 100%;
    height: auto;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;

    position: absolute;
    border: 1px solid $light;
    border-radius: $block-border-radius;
    cursor: grab;
    width: 500px;

    .flow-body {
      padding: 1rem;
    }

    .flow-header {
      padding: .5rem 1rem;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
      background-color: $light-success;
      border-bottom: 1px solid #edf2f9;
    }

    &:hover, &.jtk-drag-hover, &.selected-hover {
      border: 1px solid $primary;
    }
  }
</style>
